// import { axiosYtApiV2 } from "@/services/axios-yt-api-v2.js";
import profileMenu from "@/store/modules/profile-menu";
export async function profileMenuGet() {
  return Promise.resolve({
    success: true,
    data: profileMenu.state.items,
  });
}
